import styled from '@emotion/styled';

const Container = styled.div`
  background-color: ${({ theme }) => theme.NeutralColorLightHigh};
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const S = { Container };

export default S;
